import { type CardIdType } from '@/defs/card'
import { type IconType } from '@/defs/icon'

export const CLIPBOARD_CARD_STATUS = ['saved', 'unsaved'] as const
export type ClipboardCardStatusType = (typeof CLIPBOARD_CARD_STATUS)[number]
export const CLIPBOARD_CARD_STATUS_LABELS: Record<ClipboardCardStatusType, { actionLabel: string; icon: IconType }> = {
  saved: { actionLabel: 'Remove from Clipboard', icon: 'circleCheck' },
  unsaved: { actionLabel: 'Add to Clipboard', icon: 'plus' },
}

export type ClipboardCardType = {
  cardId: CardIdType
  isCommander?: true
}
